import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=1d8f28b2"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=1d8f28b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports